import { render, staticRenderFns } from "./DialogSucessoErro.vue?vue&type=template&id=181b329c&scoped=true"
import script from "./DialogSucessoErro.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSucessoErro.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DialogSucessoErro.vue?vue&type=style&index=0&id=181b329c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181b329c",
  null
  
)

export default component.exports